import { render } from "./DebugPanel.vue?vue&type=template&id=80e7f072&scoped=true"
import script from "./DebugPanel.vue?vue&type=script&lang=js"
export * from "./DebugPanel.vue?vue&type=script&lang=js"

import "./DebugPanel.vue?vue&type=style&index=0&id=80e7f072&scoped=true&lang=css"

import exportComponent from "/home/d6338/zsurvey-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80e7f072"]])

export default __exports__